import { IconButton, Pagination, Checkbox, Chip, Box, alpha } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getPermissionData, getUserData } from "../../Actions/common";
import {
    deleteTenantByIdAction,
    deleteMultipleTenantByIdAction,
    getTenantAction,
    getBothTenantAction,
    updateTenantStatusAction,
    updateTenantAutopayAction,
    renewTenantPlanAction,
    getTenantCurrenciesAction,
    getTenantDetailByIdAction,
    updateQbotWorkflowStatusAction,
} from "../../Actions/TenantActions";

import { getSubscriptionPlanAction } from "../../Actions/SubscriptionPlansAction";
import { CustomSwitch } from "../../Assets/customTheme/customswitch";
import {
    default as CoustomTooltip,
    default as CustomTooltip,
} from "../../Assets/customTheme/customtooltip";
import { MyCheckboxIcon, MyAddRoundedIcon, MyAutorenewIcon, MyDeleteOutlineOutlinedIcon, MyEditOutlinedIcon, MySearchIcon } from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import { CommonTooltip } from "../../utils/tooltip";
import showConfirmation from "../../utils/Conformation";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import { useLocation } from "react-router-dom";
import DataTable from "../../components/DataTable/DataTable";
import TenantStatusSelect from "./TenantStatusSelect";




const TenantSection = () => {
    const location = useLocation();
    const [MerchantData, setMerchantData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(true);
    const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
    const [statusFilter, setStatusFilter] = useState("all");
    const [portalFilter, setPortalFilter] = useState("");
    const [appliedPortalFilter, setAppliedPortalFilter] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const navigate = useNavigate();
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [shouldFetchData, setShouldFetchData] = useState(1);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
        ITEMS_PER_PAGE_OPTIONS[0]
    );
    const userData = localStorage.getItem("userData") ? getUserData() : null;
    const permissionData = localStorage.getItem(
        `${userData?.id}_permissionData`
    )
        ? getPermissionData(`${userData?.id}_permissionData`)
        : [];
    const hasPermission = permissionData[0]?.role_permissions?.find(
        (m) => m?.module && m?.module?.slug === "onboarding-tenant"
    );

    useEffect(() => {
        if (location.state?.snackbar) {
            setSnackbar({
                open: true,
                message: location.state.snackbar.message,
                severity: location.state.snackbar.severity,
            });
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    useEffect(() => {
        if (shouldFetchData) {
            getMerchantData();
            setShouldFetchData(0);
        }
        // eslint-disable-next-line
    }, [shouldFetchData]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const getMerchantData = async () => {
        setLoading(true);
        await getBothTenantAction(
            currentPage,
            searchValue,
            selectedRowsPerPage,
            statusFilter,
            portalFilter
        )
            .then((res) => {
                const { data, totalRecords } = res.data;
                setMerchantData(data);
                setTotalRecords(totalRecords);
                setLoading(false);
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message: error.response.data.message,
                    severity: "error",
                });
            });
        setLoading(false);
    };

    const filters = [
        {
            type: "search",
            name: "search",
            placeholder: "Search Tenant",
        },
        {
            type: "select",
            name: "status",
            label: "Status",
            defaultValue: "all",
            options: [
                { label: "All Status", value: "all" },
                { label: "Active", value: "1" },
                { label: "Not Active", value: "0" },
            ],
        },
        {
            type: "select",
            name: "portal",
            label: "Portal",
            defaultValue: "",
            options: [
                { label: "All Portals", value: "" },
                { label: "Qbot", value: "qbot" },
                { label: "PayCentral", value: "paycentral" },
                { label: "KYC", value: "kyc" },
                { label: "Tripola", value: "tripola" },
            ],
        },
    ];

    // const getMerchantData = async () => {
    //     setLoading(true);

    //     try {
    //         const [tenantRes, orgRes] = await Promise.all([
    //             getTenantAction(currentPage, searchValue, selectedRowsPerPage, statusFilter),
    //             getOrganizations(currentPage, searchValue, selectedRowsPerPage) // adjust params if needed
    //         ]);

    //         const tenantData = tenantRes?.data?.data || [];
    //         const orgData = orgRes?.data?.data || [];

    //         // 🔥 Normalize both APIs into SAME STRUCTURE
    //         const formattedTenant = tenantData.map((item) => ({
    //             ...item,
    //             userType: "tenant",
    //         }));

    //         const formattedOrg = orgData.map((item) => ({
    //             id: item.id,
    //             companyName: item.organizationName,
    //             domainUrl: item.domainUrl || "-",
    //             companyEmail: item.email,
    //             firstName: item.firstName || "",
    //             lastName: item.lastName || "",
    //             companyPhoneNumber: item.phoneNumber || "-",
    //             isAutoPay: item.isAutoPay || false,
    //             status: item.status || 0,
    //             updatedAt: item.updatedAt,
    //             isActive: item.isActive,
    //             userType: "organization", // 👈 important
    //         }));

    //         const combinedData = [...formattedTenant, ...formattedOrg];

    //         setMerchantData(combinedData);
    //         setTotalRecords(combinedData.length); // or sum of both APIs
    //     } catch (error) {
    //         setSnackbar({
    //             open: true,
    //             message: error?.response?.data?.message || "Error fetching data",
    //             severity: "error",
    //         });
    //     }

    //     setLoading(false);
    // };



    const handleDeleteTenant = async (e, tenantId) => {
        e.stopPropagation();

        const payload = {
            commonId: tenantId,
        };

        await showConfirmation("delete", {
            entityName: "Tenant",
            entityId: tenantId,
            action: async ({ deleteType }) => {
                return await deleteTenantByIdAction({
                    ...payload,
                    deleteType,
                });
            },
            onSuccess: (res, deleteType) => {
                setSnackbar({
                    open: true,
                    message: res?.message || res?.data?.message || `Tenant ${deleteType} deleted successfully`,
                    severity: "success",
                });
                getMerchantData();
            },
            onError: (error) => {
                setSnackbar({
                    open: true,
                    message: error?.response?.data?.message || "Something went wrong",
                    severity: "error",
                });
            },
            showCancelledMsg: true,
        });
    };

    const changeMerchantStatus = async (e, ele) => {
        e.stopPropagation();

        const newStatus = !ele.isActive;
        const actionText = newStatus ? "Activate" : "Deactivate";

        const result = await Swal.fire({
            title: `${actionText} Tenant?`,
            text: `Are you sure you want to ${actionText.toLowerCase()} this tenant?`,
            icon: newStatus ? "question" : "warning",
            showCancelButton: true,
            confirmButtonColor: newStatus ? "#28a745" : "#dc3545",
            cancelButtonColor: "#777777",
            confirmButtonText: `Yes, ${actionText}`,
            cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
            await updateTenantStatusAction(ele.id, ele.isActive)
                .then((res) => {
                    setSnackbar({
                        open: true,
                        message: res.data.message,
                        severity: "success",
                    });
                    getMerchantData();
                })
                .catch((error) => {
                    setSnackbar({
                        open: true,
                        message: error.response.data.message,
                        severity: "error",
                    });
                });
        }
    };

    // const changeTenantAutopay = async (e, ele) => {
    //     e.stopPropagation();
    //     const newAutopayStatus = !ele.isAutoPay;

    //     await showConfirmation("customToggle", {
    //         entityName: "Autopay",
    //         entityId: ele.id,
    //         isActivating: newAutopayStatus,
    //         action: updateTenantAutopayAction,
    //         customTitle: newAutopayStatus ? "Enable Autopay?" : "Disable Autopay?",
    //         customHtml: newAutopayStatus
    //             ? `
    //                 <p class="mb-3">Are you sure you want to enable autopay for <strong>${ele.companyName}</strong>?</p>
    //                 <div class="alert alert-info bg-info-subtle border border-info-subtle text-start p-3 mb-0">
    //                     <strong>Note:</strong> This will be applicable from the next billing cycle.
    //                 </div>
    //             `
    //             : `
    //                 <p class="mb-3">Are you sure you want to disable autopay for <strong>${ele.companyName}</strong>?</p>
    //                 <div class="alert alert-warning bg-warning-subtle border border-warning-subtle text-start p-3 mb-0">
    //                     <strong>Warning:</strong> Once disabled, payments will need to be processed manually.
    //                 </div>
    //             `,
    //         confirmButtonText: newAutopayStatus ? "Yes, Enable Autopay" : "Yes, Disable Autopay",
    //         confirmButtonColor: newAutopayStatus ? "#22419e" : "#dc3545",
    //         onSuccess: (res) => {
    //             setSnackbar({
    //                 open: true,
    //                 message: res?.message || `Autopay ${newAutopayStatus ? "enabled" : "disabled"} successfully`,
    //                 severity: "success",
    //             });
    //             getMerchantData();
    //         },
    //         onError: (error) => {
    //             setSnackbar({
    //                 open: true,
    //                 message: error?.response?.data?.message || "Something went wrong",
    //                 severity: "error",
    //             });
    //         },
    //     });
    // };
    const handleDeleteSelected = (ids = selectedRows) => {
        if (ids.length === 0) {
            return;
        }

        Swal.fire({
            title: "Are you sure you want to delete selected Tenants?",
            html: `
                <p class="mb-3">You will not be able to recover these tenants.</p>

                <div class="alert alert-warning bg-warning-subtle border border-warning-subtle text-start p-3 mb-0 text-muted
">
                    <div class="mb-2">
                        <strong class="text-danger">Hard Delete</strong>
                        <p class="mb-1">
                            Permanently removes selected tenants and
                            <strong>all their transactions</strong>.
                        </p>
                    </div>
                    <hr>
                    <div>
                        <strong class="text-primary">Soft Delete</strong>
                        <p class="mb-0">
                            Deactivates tenants while preserving
                            <strong>transaction history</strong>.
                        </p>
                    </div>
                </div>
            `,
            icon: "warning",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonColor: "#d33", // Hard Delete = red
            denyButtonColor: "#22419e", // Soft Delete = blue
            cancelButtonColor: "#777777",
            confirmButtonText: "Hard Delete",
            denyButtonText: "Soft Delete",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            let deleteType = null;

            if (result.isConfirmed) deleteType = "hard";
            if (result.isDenied) deleteType = "soft";

            if (deleteType) {
                try {
                    await deleteMultipleTenantByIdAction({
                        selectedRows: ids,
                        deleteType,
                    })
                        .then((res) => {
                            Swal.fire({
                                title: "Deleted!",
                                text: res.data.message,
                                icon: "success",
                                confirmButtonColor: "#22419e",
                            });
                            setSelectedRows([]);
                            setCurrentPage(1);
                            setShouldFetchData(1);
                        })
                        .catch((error) => {
                            setSnackbar({
                                open: true,
                                message: error.response.data.message,
                                severity: "error",
                            });
                            setSelectedRows([]);
                        });
                } catch (error) {
                    console.error(
                        "Error -> Something went wrong while multiple delete"
                    );
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe",
                    icon: "error",
                    confirmButtonColor: "#22419e",
                });
                setSelectedRows([]);
            }
        });
    };

    // const handleChangeDropdown = (e, filterName) => {
    //     const selectedAction = e.target.value;
    //     if (selectedAction === "all") {
    //         setFilterButtonDisabled(true);
    //     } else {
    //         setFilterButtonDisabled(false);
    //     }
    //     if (filterName === "status") {
    //         setStatusFilter(selectedAction);
    //     }
    // };

    const handleFilterReset = () => {
        setSearchValue("");
        setStatusFilter("all");
        setPortalFilter("");
        setAppliedPortalFilter("");
        setCurrentPage(1);
        setShouldFetchData(1);
    };

    const handleBulkAction = async (type, ids) => {
        if (type !== "delete") return;
        setSelectedRows(ids);
        handleDeleteSelected(ids);
    };

    const handleTableAction = (action, row) => {
        switch (action) {
            case "edit":
                handleSelectId(row);
                break;

            case "delete":
                handleDeleteTenant(
                    { stopPropagation: () => { } },
                    row.id
                );
                break;

            case "activate":
            case "deactivate":
                changeMerchantStatus(
                    { stopPropagation: () => { } },
                    row
                );
                break;
            case "clone":
                navigate("/tenant/edit", {
                    state: {
                        id: row.id,
                        isCloneTenant: true,
                    }
                });
                break;

            default:
                break;
        }
    };



    const handleSelectId = (row) => {
        navigate("/tenant/edit", {
            state: {
                id: row.id,
                source: portalFilter || "common",
                assignPortal: row.assignPortal
            }
        });
    };
    // const handleSelectId = (row) => {
    //     navigate("/tenant/edit", {
    //         state: {
    //             id: row.id,
    //             source: row.qbotTenant
    //                 ? "qbot"
    //                 : row.paycentralTenant
    //                     ? "paycentral"
    //                     : row.kycTenant
    //                         ? "kyc"
    //                         : row.tripolaTenant
    //                             ? "tripola"
    //                     : "common",
    //             assignPortal: row.assignPortal
    //         }
    //     });
    // };



    const handleRenewPlan = async (e, tenant) => {
        e.stopPropagation();

        try {
            // Fetch full tenant details to get billingCycle from plan history
            const [planResponse, currencyResponse, tenantDetailRes] = await Promise.all([
                getSubscriptionPlanAction(1, "", 100, "all"),
                getTenantCurrenciesAction(),
                getTenantDetailByIdAction(tenant.id),
            ]);

            const plans = planResponse?.data?.data || [];
            const currentPlan = plans.find(p => p.id === tenant.planId);

            if (!currentPlan) {
                setSnackbar({
                    open: true,
                    message: "Plan details not found",
                    severity: "error",
                });
                return;
            }

            // Get currency symbol
            const currencies = currencyResponse?.data?.data || [];
            const currency = currencies.find(c => c.id === tenant.currency);
            const currencySymbol = currency?.symbol || "$";

            // Use the billing cycle from the tenant's last plan history record
            const billingCycle = tenantDetailRes?.data?.billingCycle || "monthly";
            const planAmount = billingCycle === "yearly"
                ? currentPlan.yearly_price
                : currentPlan.monthly_price;

            // For custom plans, use the custom plan price; otherwise use the plan's billing-cycle price
            const isCustomPlan = tenant.isCustomPlan && tenant.customPlanId;
            const displayAmount = isCustomPlan && tenant.customPlanDetails?.price
                ? tenant.customPlanDetails.price
                : planAmount;

            const result = await Swal.fire({
                title: "Renew Plan Confirmation",
                html: `
                    <div class="text-start">
                        <p class="mb-4">Please review the plan renewal details for <strong>${tenant.companyName}</strong>:</p>
                        
                        <div class="card border mb-3">
                            <div class="card-body p-3">
                                <h6 class="card-title mb-3 text-primary">Plan Details</h6>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Plan Name:</div>
                                    <div class="col-6 fw-semibold">${currentPlan.name}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Billing Cycle:</div>
                                    <div class="col-6 fw-semibold text-capitalize">${billingCycle}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-6 text-muted">Payment Mode:</div>
                                    <div class="col-6 fw-semibold text-capitalize">${tenant.paymentMode || "online"}</div>
                                </div>
                                <hr class="my-2">
                                <div class="row">
                                    <div class="col-6 text-muted fw-bold">Total Amount:</div>
                                    <div class="col-6 fw-bold text-primary fs-5">${currencySymbol}${displayAmount}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="alert alert-info mb-0">
                            <strong>Note:</strong> ${tenant.paymentMode === "online"
                        ? "A payment link will be sent to your registered email address."
                        : "Your renewal request will be processed manually by our team."}
                        </div>
                    </div>
                `,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#22419e",
                cancelButtonColor: "#777777",
                confirmButtonText: "Yes, Renew Plan",
                cancelButtonText: "Cancel",
                width: "600px",
            });

            if (result.isConfirmed) {
                const renewData = {
                    tenantId: tenant.id,
                    planId: tenant.planId,
                    billingCycle: billingCycle,
                    paymentMode: tenant.paymentMode || "online",
                    isAutoPay: tenant.isAutoPay || false,
                    isCustomPlan: tenant.isCustomPlan || false,
                    customPlanDetails: tenant.customPlanId && tenant.customPlanDetails ? {
                        messageLimit: tenant.message_limit,
                        userLimit: tenant.user_limit,
                        agentLimit: tenant.agent_limit,
                        price: tenant.customPlanDetails?.price || null,
                        currency: tenant.customPlanDetails?.currency || tenant.currency,
                    } : (tenant.customPlanId ? {
                        messageLimit: tenant.message_limit,
                        userLimit: tenant.user_limit,
                        agentLimit: tenant.agent_limit,
                    } : null),
                    allowedFeatures: tenant.allowedFeatures || {},
                };

                const response = await renewTenantPlanAction(renewData);

                Swal.fire({
                    title: "Success!",
                    html: `
                        <div class="text-center">
                            <p class="mb-3">${response.message || "Plan renewal request has been submitted successfully"}</p>
                            ${tenant.paymentMode === "online"
                            ? `<div class="alert alert-success">
                                    Payment link has been sent to <strong>${tenant.companyEmail}</strong>
                                   </div>`
                            : `<div class="alert alert-info">
                                    Your request is being processed. You will be notified once approved.
                                   </div>`}
                        </div>
                    `,
                    icon: "success",
                    confirmButtonColor: "#22419e",
                });

                getMerchantData();
            }
        } catch (error) {
            console.error("Renewal error:", error);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || "Failed to renew plan",
                severity: "error",
            });
        }
    };

    const handleWorkflowStatusChange = async (
        row,
        status
    ) => {
        await updateQbotWorkflowStatusAction(
            row.id,
            status
        )
            .then((response) => {
                setSnackbar({
                    open: true,
                    message: "Status updated successfully",
                    severity: "success",
                });

                getMerchantData();
            })
            .catch((error) => {
                setSnackbar({
                    open: true,
                    message:
                        error?.response?.data?.message,
                    severity: "error",
                });
            });
    };

    const columns = [

        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 150,
            flex: 1.5,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {
                        params.row.qbotTenant?.companyName ||
                        params.row.paycentralTenant?.businessName ||
                        params.row.kycTenant?.companyName ||
                        params.row.tripolaTenant?.companyName ||
                        "-"
                    }
                </span>
            ),
        },
        {
            field: "companyEmail",
            headerName: "Company Email",
            minWidth: 180,
            flex: 1.5,
            renderCell: (params) => (
                <span style={{ fontSize: 15, color: "#333" }}>
                    {
                        params.row.qbotTenant?.companyEmail ||
                        params.row.paycentralTenant?.email ||
                        params.row.kycTenant?.companyEmail ||
                        params.row.tripolaTenant?.companyEmail ||
                        "-"
                    }
                </span>
            ),
        },
        {
            field: "name",
            headerName: "Name",
            minWidth: 180,
            flex: 2,
            renderCell: (params) => {
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            style={{
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#333",
                            }}
                        >
                            {params.row.firstName} {params.row.lastName}
                        </span>
                    </div>
                );
            },
        },
        // {
        //     field: "companyPhoneNumber",
        //     headerName: "Phone Number",
        //     minWidth: 130,
        //     flex: 1.2,
        //     renderCell: (params) => (
        //         <span style={{ fontSize: 15, color: "#333" }}>
        //             {
        //                 params.row.qbotTenant?.companyPhoneNumber ||
        //                 params.row.paycentralTenant?.phoneNumber ||
        //                 params.row.kycTenant?.phoneNumber ||
        //                 params.row.tripolaTenant?.companyPhoneNumber ||
        //                 "-"
        //             }
        //         </span>
        //     ),
        // },
        // {
        //     field: "isAutoPay",
        //     headerName: "Autopay",
        //     minWidth: 120,
        //     flex: 0.8,
        //     renderCell: (params) => (
        //         <CustomSwitch
        //             checked={params.row.isAutoPay}
        //             onClick={(e) => changeTenantAutopay(e, params.row)}
        //         />
        //     ),
        // },
        {
            field: "status",
            headerName: "Status",
            minWidth: 150,
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                if (params.row.qbotTenant) {
                    return (
                        <TenantStatusSelect
                            variant="qbot"
                            value={params.row.qbotTenant?.status ?? "0"}
                            onChange={(status) =>
                                handleWorkflowStatusChange(params.row, status)
                            }
                        />
                    );
                }

                const portalStatus =
                    params.row.paycentralTenant?.status ??
                    params.row.kycTenant?.status ??
                    params.row.tripolaTenant?.status ??
                    "0";

                return (
                    <TenantStatusSelect
                        variant="other"
                        value={portalStatus}
                        onChange={(status) =>
                            handleWorkflowStatusChange(params.row, status)
                        }
                    />
                );
            },
        },
        {
            field: "userType",
            headerName: "Assign Portals",
            minWidth: 260,
            flex: 1.2,
            sortable: false,
            renderCell: (params) => {
                let types = [];

                if (params.row.qbotTenant) {
                    types.push({ label: "QBot", color: "primary" });
                }

                if (params.row.paycentralTenant) {
                    types.push({ label: "PayCentral", color: "success" });
                }

                if (params.row.kycTenant) {
                    types.push({ label: "KYC", color: "warning" });
                }

                if (params.row.tripolaTenant) {
                    types.push({ label: "Tripolaa", color: "secondary" });
                }

                if (appliedPortalFilter) {
                    const portalMap = {
                        qbot: "Tenant",
                        paycentral: "PayCentral",
                        kyc: "KYC",
                        tripola: "Tripola",
                    };

                    types = types.filter(
                        (type) => type.label === portalMap[appliedPortalFilter]
                    );
                }

                return (
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.8,
                            alignItems: "center",
                            alignContent: "center", // important for wrapped rows
                            justifyContent: "flex-start",
                            height: "100%",
                            py: 1,
                        }}
                    >
                        {types.length ? (
                            types.map((type, index) => (
                                <Chip
                                    key={index}
                                    label={type.label}
                                    color={type.color}
                                    size="small"
                                    // sx={{
                                    //     fontWeight: 600,
                                    //     borderRadius: "8px",
                                    // }}
                                    sx={(theme) => {
                                        const colorMap = {
                                            primary: theme.palette.primary.main,
                                            success: theme.palette.success.main,
                                            warning: theme.palette.warning.main,
                                            secondary: theme.palette.secondary.main,
                                        };

                                        const color = colorMap[type.color];

                                        return {
                                            fontWeight: 600,
                                            borderRadius: "8px",
                                            color: color,
                                            backgroundColor: alpha(color, 0.12), // transparent background
                                            border: `1px solid ${alpha(color, 0.25)}`,
                                        };
                                    }}
                                />
                            ))
                        ) : (
                            "-"
                        )}
                    </Box>
                );
            },
        },
        {
            field: "updatedAt",
            headerName: "Updated At",
            minWidth: 150,
            flex: 1.2,
            renderCell: (params) => (
                <span style={{ fontSize: 14, fontWeight: 400, color: "#555" }}>
                    {params.row.updatedAt
                        ? formatDateTime(params.row.updatedAt, true)
                        : "N/A"}
                </span>
            ),
        },
        {
            field: "renew",
            headerName: "Renew Plan",
            minWidth: 120,
            flex: 1,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                // Use isPlanExpired from backend response
                const isPlanExpired = params.row?.isPlanExpired || false;

                return isPlanExpired ? (
                    <>
                        {hasPermission?.canEdit && (
                            <CommonTooltip title="Renew Plan" placement="top" arrow>
                                <IconButton
                                    className="btn-custom-i text-primary me-3"
                                    onClick={(e) => handleRenewPlan(e, params.row)}
                                >
                                    <MyAutorenewIcon />
                                </IconButton>
                            </CommonTooltip>
                        )}
                    </>
                ) : (
                    <span style={{ fontSize: 14, color: "#999" }}>-</span>
                );
            },
        },
    ]

    const filterValues = {
        search: searchValue,
        status: statusFilter,
        portal: portalFilter,
    };

    const handleFilterApply = (values) => {
        setSearchValue(values.search || "");
        setStatusFilter(values.status || "all");
        setPortalFilter(values.portal || "");

        setCurrentPage(1);
        setShouldFetchData(1);

        setAppliedPortalFilter(values.portal || "");
    };
    return (
        <div id="kt_content_container">
            <BreadcrumbsComponent />

            <DataTable
                columns={columns}
                rows={MerchantData}
                loading={loading}
                totalCount={totalRecords}
                page={currentPage}
                pageSize={selectedRowsPerPage}
                filters={filters}
                filterValues={filterValues}
                onFilterApply={handleFilterApply}
                onFilterReset={handleFilterReset}
                onPageChange={(page) => {
                    setCurrentPage(page);
                    setShouldFetchData(1);
                }}
                onPageSizeChange={(size) => {
                    setSelectedRowsPerPage(size);
                    setCurrentPage(1);
                    setShouldFetchData(1);
                }}
                addButtonText="ADD"
                onAddClick={() => navigate("/tenant/add")}
                hasCreatePermission={hasPermission?.canCreate}
                actions={{
                    clone: hasPermission?.canCreate,
                    edit: hasPermission?.canEdit,
                    delete: hasPermission?.canDelete,
                    activate: hasPermission?.canEdit,
                }}
                bulkActions={{
                    delete: hasPermission?.canDelete,
                }}
                onAction={handleTableAction}
                onBulkAction={handleBulkAction}
            />


            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </div>
    );
};

export default TenantSection;
